export default __webpack_public_path__ + "static/media/kid03.9fdb869b.jpg";